export const OffertaStato = Object.freeze({
  INVIATA: "INVIATA",
  ACCETTATA: "ACCETTATA",
  RIFIUTATA: "RIFIUTATA",
  SCADUTA: "SCADUTA",
});

export const offertaVoceShape = {
  descrizione: "",
  prezzo: 0,
  prezzoBase: 0,
  quantita: 1,
  scontoPercentuale: 0,
  scontoValore: 0,
};

export const offertaShape = {
  id: "",
  sellerId: "",
  sellerName: "",
  prezzoTotale: 0,
  prezzoSubtotale: 0,
  distanzaKm: 0,
  tempoStimatoMin: 0,
  evasioneStimata: "",
  costoSpedizione: 0,
  scontoOrdinePercentuale: 0,
  scontoOrdineValore: 0,
  stato: OffertaStato.INVIATA,
  letta: false,
  createdAt: "",
  voci: [offertaVoceShape],
};

export const createOffertaVoceModel = (overrides = {}) => ({
  ...offertaVoceShape,
  ...overrides,
});

export const createOffertaModel = (overrides = {}) => ({
  ...offertaShape,
  ...overrides,
  voci: Array.isArray(overrides.voci)
    ? overrides.voci.map((voce) => createOffertaVoceModel(voce))
    : [createOffertaVoceModel()],
});

